import React, { PureComponent, Fragment } from "react";
import { PropTypes } from "prop-types";
import { Transition, Popup, Icon } from "semantic-ui-react";
import { CopyToClipboard } from "react-copy-to-clipboard";

class CopyString extends PureComponent {
  static propTypes = {
    copyText: PropTypes.string.isRequired,
    displayText: PropTypes.string.isRequired,
    successText: PropTypes.string,
    failedText: PropTypes.string
  };

  static POPUP_TIME = 1500;
  static FADE_TIME = 500;

  constructor(props) {
    super(props);

    this.state = {
      color: "grey",
      visible: false,
      successText: props.successText || "Copied to clipboard",
      failedText: props.failedText || "Copy failed",
      resetTimeout: null
    };
  }

  // -- HANDLERS -- //

  onCopy = result => {
    const { successText, failedText } = this.state;

    this.reset();

    const popupCopy = result ? successText : failedText;

    this.setState({
      resetTimeout: setTimeout(this.reset, CopyString.POPUP_TIME),
      popupCopy,
      open: true
    });
  };

  onEnter = evt => {
    this.setState({ visible: true });
  };

  onLeave = evt => {
    this.setState({ visible: false, open: false });
  };

  reset = () => {
    const { resetTimeout } = this.state;
    clearTimeout(resetTimeout);
    this.setState({ open: false });
  };

  setNode = node => this.setState({ node });

  // -- RENDER -- //

  render() {
    const { copyText, displayText } = this.props;
    const { color, node, popupCopy, visible, open } = this.state;

    return (
      <Fragment>
        <Popup
          context={node}
          content={popupCopy}
          position="top right"
          open={open}
          size="mini"
          inverted
          offset={[8, 0]}
        />
        <CopyToClipboard
          text={copyText}
          onCopy={this.onCopy}
          onMouseEnter={this.onEnter}
          onMouseLeave={this.onLeave}
        >
          <span className="copy-string" ref={this.setNode}>
            {displayText}
            <Transition
              mountOnShow={false} // needed or we cannot maintain spacing in dropdown menus
              visible={visible}
              animation="scale"
              duration={CopyString.FADE_TIME}
            >
              <Icon
                className="copy-string-icon"
                color={color}
                name="copy outline"
                size="small"
              />
            </Transition>
          </span>
        </CopyToClipboard>
      </Fragment>
    );
  }
}

export default CopyString;
